import { render, staticRenderFns } from "./ImplantsSuppliers.vue?vue&type=template&id=0dcf4624&scoped=true"
import script from "./ImplantsSuppliers.vue?vue&type=script&lang=js"
export * from "./ImplantsSuppliers.vue?vue&type=script&lang=js"
import style0 from "./ImplantsSuppliers.vue?vue&type=style&index=0&id=0dcf4624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcf4624",
  null
  
)

export default component.exports